import InOutCardsWidgetView from './InOutCardsWidgetView.vue';

export const type = 'inOutCards';
export const view = InOutCardsWidgetView;

export function builder() {
  return {
    type,
    top: 0,
    rotate: 0,
    zIndex: 1,
    inColor: '#13C636',
    outColor: '#FF67A1',
    textColor: '#205441',
    fontFamily: 'SimplerPro',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
    gap: 15,
    marginLeft: 30,
    variableName: '',
    variableData: [
      {
        monthName: 'January',
        in: 3200,
        out: 4000,
      },
      {
        monthName: 'February',
        in: 3500,
        out: 3200,
      },
      {
        monthName: 'March',
        in: 2900,
        out: 3100,
      },
      {
        monthName: 'April',
        in: 3800,
        out: 3300,
      },
    ],
  };
}
